export default __webpack_public_path__ + "static/Step-8-7f81355df722ad3d0a325ac8954def44.svg";